import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/ko";

import { Skeleton } from "components/ui/Skeleton";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/Table";
import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";

dayjs.locale("ko");

const StyledCard = styled(Card)`
  box-shadow: none;
  padding: 0 16px;
  gap: 0;
  border: none;
`;

const StyledCardHeader = styled(CardHeader)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 12px;
`;

const StyledCardTitle = styled(CardTitle)`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: #333333;
`;

const StyledCardContent = styled(CardContent)`
  padding-left: 0;
  padding-right: 0;
`;

const OverflowWrapper = styled.div`
  overflow-x: auto;
`;

const SkeletonFullWidth = styled(Skeleton)`
  height: 20px;
  width: 100%;
`;

export const SalesDataTableSkeleton = () => {
  const { searchParams } = useUpdateUrlParams();
  const referenceMonth = searchParams.get("month") || dayjs().format("YYYY-MM");

  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>
          {dayjs(referenceMonth).format("YY년 M월")} 매출 내역
        </StyledCardTitle>
      </StyledCardHeader>
      <StyledCardContent>
        <OverflowWrapper>
          <Table>
            <TableHeader>
              <TableRow>
                {[...Array(7)].map((_, i) => (
                  <TableHead key={i}>
                    <SkeletonFullWidth />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...Array(5)].map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {[...Array(7)].map((_, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <SkeletonFullWidth />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </OverflowWrapper>
      </StyledCardContent>
    </StyledCard>
  );
};
